<template>
  <div class="d-page-wrapper">
    <v-container fluid>
      <v-row>
        <v-col cols="12" md="12">
          <v-card outlined>
            <v-card-title v-if="currentChain && currentChain.name">
              <div>
                <div class="headline">{{ currentChain.name }}</div>
              </div>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
              <div v-if="sanitizedGuidelines && sanitizedGuidelines.trim() !== ''" class="guidelines-body" v-html="sanitizedGuidelines"></div>
              <div v-else class="text--disabled">{{ $t('guidelines.noGuidelinesAssigned') }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DOMPurify from 'dompurify'
import pageMixin from '@/mixins/page.mixin'
import snackbarMixin from '@/mixins/snackbar.mixin'

export default {

  mixins: [
    pageMixin,
    snackbarMixin
  ],

  data () {
    return {
      guidelines: ''
    }
  },


  computed: {
    ...mapGetters('chain', ['currentChainId', 'currentChain']),

    sanitizedGuidelines () {
      // Ensure guidelines is a string and sanitize it before rendering with v-html
      return DOMPurify.sanitize(this.guidelines || '')
    },

    tableHeaders () {
      const headers = [
        { text: this.$t('service.table.vehicleLicenseNumber'), value: 'vehicleLicenseNumber', cellClass: 'text-no-wrap' },
        { text: this.$t('service.table.date'), value: 'date', cellClass: 'text-no-wrap' },
        { text: this.$t('service.table.type'), value: 'serviceTypeName' },
        { text: this.$t('service.table.mileage'), value: 'mileage' },
        { text: this.$t('service.table.glassProtection'), value: 'glassProtection' },
        { text: this.$t('service.table.comment'), value: 'comment', cellClass: 'd-overflow-ellipsis' }
      ]

      return headers
    }
  },


  methods: {
    ...mapActions('guidelines', ['updateGuidelines']),
    ...mapActions('chain', ['getChainById']),

    async loadGuidelinesForChain (chainId) {
      // Fetch the full chain and update the local guidelines content.
      try {
        this.startPageLoading()
        const chain = await this.getChainById(chainId)
        this.guidelines = chain?.guidelines || ''
      } catch (error) {
        this.showSnackbarError()
        this.$log.error(error)
      } finally {
        this.stopPageLoading()
      }
    }

  },

  watch: {
    // When user switches chain, reload guidelines for the newly selected chain
    currentChainId (newId, oldId) {
      if (newId !== oldId) {
        this.loadGuidelinesForChain(newId)
      }
    }
  },


  async created () {
    this.setPageTitle(this.$t('nav.guidelines'))
    // Load initial guidelines for the currently selected chain (if any)
    if (this.currentChainId) {
      await this.loadGuidelinesForChain(this.currentChainId)
    }
  }
}
</script>

<style scoped>
.guidelines-body {
  /* Make rendered HTML match project typography and be readable */
  font-size: 14px;
  line-height: 1.6;
}
.guidelines-body img {
  max-width: 100%;
  height: auto;
}
.guidelines-body a {
  color: var(--v-theme-primary);
  text-decoration: underline;
}
</style>
